var React = require('react');
var DateFormatter = require('../../Formatters/DateFormatter');

var style ={
	container: {
		display: 'flex',
		justifyContent: 'space-between',
		borderBottom: 'solid 1px #ccc',
		padding: '5px 0px',
		alignItems: 'center'
	},

	box: {
		display: 'flex',
		flexDirection: 'column',
	}
};

var Order = React.createClass({
	getStatus: function(status) {
		var label;

		switch(status) {
			case 1:
				label = 'Em aberto';
				break;

			case 2:
				label = 'Em entrega';
				break;

			case 3:
				label = 'Entregue'
				break;

			case 4:
				label = 'Cancelado'
				break;

			default:
				label = 'Esperando confirmação do pagamento';
				break;
		}

		return label;
	},

	render: function() {
		var me = this;

		return (
			<a 	style={style.container} onClick={() => me.props.onClick(me.props.id)}>
				<div style={style.box}>
					<span>
						<b>{"Pedido"} </b> {me.props.order}
					</span>
					<span>
						<b>{"Status"} </b> {me.getStatus(me.props.status)}
					</span>
					<span>
						<b>{"Data"} </b> <DateFormatter data={me.props.createdAt}/>
					</span>
				</div>

				<i className="icon-right-open"/>
			</a>
		);
	}

});

module.exports = Order;


// WEBPACK FOOTER //
// ./src/components/Client/MyOrders/Order.jsx